import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=e55f0b42&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=e55f0b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55f0b42",
  null
  
)

export default component.exports